module.exports = __webpack_public_path__ + "img/04-3-5见即所得.52ee4faa.svg";